import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import StarHalf from '@material-ui/icons/StarHalf';

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  starContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  star: {
    fontSize: '18px',
  }
});


class RatingStars extends React.Component {

  render() {
    const { classes, valueScore, fS } = this.props;
    let fontSize = fS;
    (fontSize === '') ? fontSize = "inherit" : fontSize = "small";

    let stars = '';

    if (valueScore < 90)
      stars = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarIcon fontSize={fontSize} key={4}/>, <StarIcon fontSize={fontSize} key={5}/>];
    else if (valueScore < 100)
      stars = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarIcon fontSize={fontSize} key={4}/>, <StarHalf fontSize={fontSize} key={5}/>];
    else if (valueScore < 110)
      stars = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarHalf fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    else if (valueScore < 120)
      stars = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    else if (valueScore < 130)
      stars = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarBorder fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    else if (valueScore < 140)
      stars = [<StarIcon fontSize={fontSize} key={1}/>, <StarBorder fontSize={fontSize} key={2}/>, <StarBorder fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    else
      stars = [<StarHalf fontSize={fontSize} key={1}/>, <StarBorder fontSize={fontSize} key={2}/>, <StarBorder fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];


    return (
      <div className={classes.starContainer}>
        {stars}
      </div>
    );
  }

}

RatingStars.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RatingStars);



// WEBPACK FOOTER //
// ./src/components/RatingStars.jsx